import React, { Component } from 'react';
import PropTypes from 'prop-types';

import DoubleCheckedIcon from '../../assets/images/svg/doubleCheck.svg';

class DoubleChecked extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 24,
      height: 24,
    };
  }

  setState() {
    this.setState = {
      width: this.props.width,
      height: this.props.height,
    };
  }

  render() {
    return (
      <img
        src={DoubleCheckedIcon}
        width={this.state.width}
        height={this.state.height}
        className={this.props.className || ''}
        alt={'icone-duplo-check'}
        loading='lazy'
      />
    );
  }
}

DoubleChecked.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default DoubleChecked;
